import { inject, Pipe, PipeTransform } from '@angular/core';

import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { Column } from './../../../interfaces';

@Pipe({
  name: 'formatColumnText',
  standalone: true,
})
export class FormatColumnTextPipe implements PipeTransform {
  private _capitalizePipe = inject(CapitalizePipe);

  transform(value: string | null | undefined, column?: Column): unknown {
    if (!value) {
      // exibe 0 quando configurado e o valor não for informado ou for zero
      return column?.showZero ? '0' : undefined;
    } else if (column?.lowerCase) {
      return value.toLowerCase();
    } else if (column?.upperCase) {
      return value.toUpperCase();
    } else if (column?.titleCase) {
      return value.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    } else if (column?.capitalize) {
      return this._capitalizePipe.transform(value);
    }

    return value;
  }
}
